import { ref } from 'vue'
import { DocumentContext } from '../types'
import {
  attachmentCreate,
  attachmentDelete,
  attachmentList,
} from '@/requests/attachment'
import { File } from '@/utils/types/helpers'

export function useAttachments({ documentId }: DocumentContext) {
  const attachments = ref<any[]>([])

  const getAttachmentList = () => {
    return attachmentList('document', documentId.value).then(res => {
      attachments.value = res
    })
  }

  const attachmentCreateHandler = (newAttachment: File) => {
    return attachmentCreate('document', documentId.value, newAttachment)
  }

  const attachmentDeleteHandler = (id: number) => {
    return attachmentDelete('document', documentId.value, id)
  }

  return {
    attachments,
    getAttachmentList,
    attachmentCreate: attachmentCreateHandler,
    attachmentDelete: attachmentDeleteHandler,
  }
}
